"use client";

import { HistoricalEventData } from "@/lib/hygraph";

interface TimelineDotsProps {
  events: HistoricalEventData[] | null;
}

const TimelineDots = ({ events }: TimelineDotsProps) => {
  if (!events) return null;

  return (
    <>
      {/* Pulsing dots on the cable path */}
      {events.map((event, index) => (
        <div
          key={`dot-${event.id}`}
          className="timeline-dot absolute"
          data-dot-index={index}
          style={{
            width: "16px",
            height: "16px",
            visibility: "hidden", // Will be positioned and shown by GSAP
          }}
        >
          <div
            className="dot-pulse"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              boxShadow: "0 0 10px rgba(255, 255, 255, 0.5)",
            }}
          />
        </div>
      ))}
    </>
  );
};

export default TimelineDots;
